import { render } from "./Reviews.vue?vue&type=template&id=6636d928"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"
script.render = render

export default script